
  import { defineComponent, PropType } from 'vue';

  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';

  import { FTS_GROUPING_OPTIONS } from '@/modules/ved/constants/fts/options';
  import { TFTSWeeklyFilter, TFTSWeeklyGroupingFilter } from '@/modules/ved/types/fts-weekly';

  export default defineComponent({
    name: 'FTSWeeklyGroupingFilter',
    components: { InputBlock, SelectMultiComponent },
    props: {
      modelValue: {
        type: Object as PropType<TFTSWeeklyGroupingFilter>,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    data(): { localFilter: TFTSWeeklyGroupingFilter } {
      return {
        localFilter: this.getGroupingFilter(this.modelValue),
      };
    },
    computed: {
      getGroupingTree() {
        return FTS_GROUPING_OPTIONS;
      },
      getFilteredFirstGroupOptions() {
        return this.getFilteredGroupOptions(this.localFilter.secondGroupingId);
      },
      getFilteredSecondGroupOptions() {
        return this.getFilteredGroupOptions(this.localFilter.firstGroupingId);
      },
    },
    methods: {
      getGroupingFilter(filter: TFTSWeeklyGroupingFilter): TFTSWeeklyGroupingFilter {
        return {
          firstGroupingId: filter.firstGroupingId,
          secondGroupingId: filter.secondGroupingId,
        };
      },
      getFilteredGroupOptions(groupId: TFTSWeeklyFilter['firstGroupingId']) {
        if (!groupId) return this.getGroupingTree;

        return this.getGroupingTree.filter((group) => group.value !== groupId);
      },
    },
    watch: {
      modelValue: {
        handler(newValue: TFTSWeeklyGroupingFilter) {
          const newGroupingFilter = this.getGroupingFilter(newValue);
          if (JSON.stringify(this.localFilter) !== JSON.stringify(newGroupingFilter)) {
            this.localFilter = newGroupingFilter;
          }
        },
      },
      localFilter: {
        handler(newValue: TFTSWeeklyGroupingFilter) {
          this.$emit('update:modelValue', { ...this.modelValue, ...newValue });
        },
        deep: true,
      },
    },
  });
